var NLXFramed = false;


$(function () {
  $.support.cors = true;
  $.ajaxSetup({ cache: true });

  $(document).on('click', '#launch', function () {
    $('.ui.sidebar').sidebar({
      scrollLock: true,
      closable: true,
      transition: 'overlay',
      dimPage: false,
      onHidden: function () {
        $('#hamburgerToggle').removeClass("is-active");
      },
      onVisible: function () {
        $('#hamburgerToggle').addClass("is-active");
      }
    })
      .sidebar('toggle');
  });

  //added to autodetect if in a frame or not.
  if (window.self !== window.top) {
    $("hostType").attr("data-if-framed", "true");
    $("body").addClass("iframed");
    NLXFramed = true;
  }

  if ($("#hostType").attr("data-if-framed") == "true") {
    $(".frameswitch").css("display", "none");
    checkDocumentHeight(sendSizeMsg);
  }

  function checkDocumentHeight(callback) {
    var lastHeight = $("body").outerHeight(), newHeight, timer;
    (function run() {
      newHeight = $("body").outerHeight();
      if (lastHeight != newHeight)
        callback(newHeight);
      lastHeight = newHeight;
      timer = setTimeout(run, 100);
    })();
  }

  $("#popupMessageModal").on("hidden.bs.modal", function(){
    $("#popupMessageTitle,#popupMessageContent").text('');
      var $errorInputs = $(".PSERROR");
      if ($errorInputs.length) {
        $errorInputs.first().focus();
      }
  });


  $(document).on("NLX:pageStart",function(){
    $('#loading').show()
  });
  $(document).on("NLX:pageComplete",function(){
    $('#loading').hide()
  });
  
  InFlight.NLX.Cfg.setDefaults(InFlight.NLX.Cfg.Customer.getNLXDefaults());
});

function commonCleanUp() {
  //add error className to inputs to outline them in red
  var errorInputs = document.querySelectorAll("[tmpclass=PSERROR]");
  var errorText = $("#error_items").html();
  var isError = (errorText && errorText.length > 0);
  for (var i = 0; i < errorInputs.length; i++) {
    $(errorInputs[i]).addClass("PSERROR");
  }
}

function highlightErrors(){
  $(".has-error").removeClass("has-error");
  $("[tmpclass=PSERROR]").closest(".form-group").addClass("has-error");
}

function setHiddenInput(id, value) {
  var existingElement = $("#" + id);

  if (existingElement.length === 0) {
    $("<input name='" + id + "' type='hidden' value='" + value + "' />").insertAfter("input[type='hidden']:last");
  } else {
    // we already have it, so just set the value
    existingElement.val(value);
  }
}

function updateUI(data){
  if(data && data.title){
    updateHeader(data.title);
  }
  highlightErrors();
  focusElement();
}

function updateHeader(title) {
  if ($("#hostType").attr("data-if-framed") != "true") {
    $("#header").show();
    $("#breadcrumb").html(title);
    document.title = title;
  }

  if(InFlight && InFlight.CV && InFlight.CV.NLX && InFlight.CV.NLX.Remote && InFlight.CV.NLX.Remote.changeTitle) {
    InFlight.CV.NLX.Remote.changeTitle()
  }

  if(sessionStorage.isLoggedIn !== "true"){
    $("#logoutContainer, #masterHamburger").hide();
  }else{
    $("#logoutContainer, #masterHamburger").show();
  }
}


/*
  Listens for enter key presses while an input is focused.
  If on lookup input, triggers lookup. Otherwise, suppresses
  further functionality. 
*/
function handleEnterPresses() {
  $('input').off('keydown').on('keydown', function (e) {
    if (e.which === 13) { //enter
      var active = $(document.activeElement);
      var button = active.parent('.input-group').find('button');
      if (button.length === 1) {
        button.trigger("click");
      } 

      e.preventDefault();
      e.stopPropagation();
    }
  });
  
}

function focusElement(){
    var text = $("#elementToFocus").text().trim();
    if(text){
      var setFocusRegex = /setFocus_win0\(['"]([^'"]*)['"],-1\)/g;
        var result = setFocusRegex.exec(text);
        if(result && result.length === 2){
            setTimeout(function(){
              var id = "[id='" + result[1] + "']";
              var $elementToFocus = $(id);

              var relatedElementIdToFocus = $elementToFocus.data("if-focus-related");
              if(relatedElementIdToFocus){
                $elementToFocus = $("[id='" + relatedElementIdToFocus + "']");
              }
              $elementToFocus.focus(function(e) {
                e.stopPropagation();
                e.preventDefault();
              });
              $elementToFocus.focus();
            },0);            
        }
    }
}
// using custom alert close handling since default bootstrap 3 logic is to remove the alert from the DOM

function showConfirmation(data) {
    var $alert = $('[data-if-label="popupMessageContentContainer"]');
    // if there's no popup message
    if(data.CaptureResults.popupMessageContent) {
        // show inline confirmation message
        $alert.show().addClass('animated fadeIn');
		// NWTC 6cd24010c0a0e13b1c001a5a5bb79f45c3d79922 : 	Removed setTimout from popups
        // setTimeout(function(){
            // $alert.removeClass('animated fadeIn');
            // $alert.hide();

        // },5000);  
    }
    else {
        $alert.hide();
    }
    $alert.find('button.close').on('click', function(){
      $alert.hide();
    });    
}